// src/components/Hero.jsx
import React from "react";
import styled from "styled-components";
import { colors } from "../styles/colors";
import { motion } from "framer-motion";
import HeroBg from "../assets/images/hero-bg.png"; 
import HeroBgMobile from "../assets/images/hero-bg-mobile.png";

const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-end; /* Keeps button positioned relative to the bottom half */
  align-items: center;
  text-align: center;
  min-height: 90vh;
  padding-bottom: 120px; /* Controls button height on desktop screens */
  
  /* Desktop Image */
  background: url(${HeroBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  /* Mobile Image Swap & Button Fine-Tuning */
  @media (max-width: 768px) {
    min-height: 85vh; /* Standardized height to match mobile screen proportions nicely */
    background: url(${HeroBgMobile}); 
    background-size: cover;
    background-position: center;
    
    /* 👇 ADJUST THIS VALUE TO MOVE THE BUTTON UP OR DOWN ON MOBILE
       - Increase it (e.g., 180px, 220px) to push the button HIGHER up the screen.
       - Decrease it (e.g., 60px, 40px) to pull the button LOWER down the screen.
    */
    padding-bottom: 140px; 
  }

  /* Extra adjustment for exceptionally small or short phone screens if needed */
  @media (max-width: 480px) {
    min-height: 80vh;
    padding-bottom: 100px; 
  }
`;

const CTAButton = styled(motion.a)`
  font-family: 'Montserrat', sans-serif;
  padding: 15px 35px;
  background-color: ${colors.primary};
  color: ${colors.secondary};
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  border-radius: 0px; 
  text-decoration: none;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  display: inline-block;

  @media (max-width: 768px) {
    padding: 12px 28px;
    font-size: 0.8rem;
    letter-spacing: 0.1em;
    width: auto;
    max-width: 90%; 
  }
`;

export default function Hero() {
  return (
    <HeroSection id="hero">
      <CTAButton
        href="#contact"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        whileHover={{ scale: 1.05, backgroundColor: "#fff" }}
        whileTap={{ scale: 0.98 }}
      >
        Book a Free Consultation
      </CTAButton>
    </HeroSection>
  );
}